module.exports = __webpack_public_path__ + "media/icons/glass-clear-ee590a761f07a9d0f1945d9969002db8.svg";